import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import '../../ExchangeNav.css';

// 언어교환 기능 안에서 쓰는 작은 탭 메뉴이다.
// 프로필 화면, 상대 찾기 화면, 매칭 요청 화면, 채팅함 화면 위에 공통으로 붙여서
// 사용자가 헷갈리지 않고 이동할 수 있게 한다.
const ExchangeNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  // 프로필 수정은 이제 여기에 있지 않다. /profile(통합 프로필 화면)에서 보여주고, 그곳의
  // "수정하기" 버튼을 누르면만 /exchange/profile로 들어오게 해서, 이 탭 메뉴에는 널지 않은다.
  const tabs = [
    { path: '/exchange', label: '상대 찾기', requiresLogin: false },
    { path: '/exchange/requests', label: '매칭 요청', requiresLogin: true },
    { path: '/exchange/chats', label: '채팅함', requiresLogin: true },
  ];

  const isActive = (path) => {
    if (path === '/exchange') {
      return location.pathname === '/exchange';
    }
    return location.pathname.startsWith(path);
  };

  // 로그인이 필요한 탭을 게스트가 누르면, 조용히 리다이렉트하지 않고 로그인이 필요하다고 먼저 알려준다.
  const handleTabClick = (e, tab) => {
    if (tab.requiresLogin && !user) {
      e.preventDefault();
      alert('로그인이 필요합니다.');
      navigate('/login');
    }
  };

  return (
    <div className="exchange-nav">
      {tabs.map((tab) => (
        <Link
          key={tab.path}
          to={tab.path}
          className={`exchange-nav-tab ${isActive(tab.path) ? 'active' : ''}`}
          onClick={(e) => handleTabClick(e, tab)}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
};

export default ExchangeNav;
